import { Navigate } from 'react-router-dom';

import { AppRoutePath } from '../../pages/AppRoutePath';

export const RedirectToRequestLink = () => <Navigate to={AppRoutePath.AuthWildcard} replace />;
